export default __webpack_public_path__ + "static/media/GMC_logo.c188a290.png";